import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { Order } from 'shell/view-models/order';
import { FiltersFormTypeDoc } from 'front-office/view-models/type-doc-list';

export const transformDataset = (values: FiltersFormTypeDoc): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    tipoDocumento: { value: otherValues.typeDoc || '', operation: Operation.EQUALS },
    codiceDocumento: { value: otherValues.code || '', operation: Operation.EQUALS },
    descrizioneDocumento: { value: otherValues.description || '', operation: Operation.LIKE },
    tipoDiritti: { value: otherValues.typeRights || '', operation: Operation.EQUALS },
    modalitaRilascio: { value: otherValues.mode || '', operation: Operation.EQUALS },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    tipoDocumento: ordersToTransform.typeDoc,
    codiceDocumento: ordersToTransform.code,
    descrizioneDocumento: ordersToTransform.description,
    tipoDiritti: ordersToTransform.typeRights,
    modalitaRilascio: ordersToTransform.mode,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
